module.exports = __webpack_public_path__ + "static/media/klitchko.2dfef97c.jpg";